import React from 'react';

import { useSolanaWallet } from '@/networks/svm';

import HeaderWalletDrawerSolanaWalletConnect from './HeaderWalletDrawerSolanaWalletConnect';
import HeaderWalletDrawerSolanaWalletDetails from './HeaderWalletDrawerSolanaWalletDetails/HeaderWalletDrawerSolanaWalletDetails';

const HeaderWalletDrawerSolanaWallet: React.FC = () => {
  const { isConnected } = useSolanaWallet();

  if (isConnected) {
    return <HeaderWalletDrawerSolanaWalletDetails />;
  }

  return <HeaderWalletDrawerSolanaWalletConnect className="h-14 w-full rounded-xl text-base" />;
};

export default HeaderWalletDrawerSolanaWallet;
